import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FileButton } from 'foundations-components/transitional/components/FileButton';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProfilePhotoSection({
  loginVerifyData,
  photo,
  loading
}) {
  const {
    displayUrl,
    showImage,
    uploading,
    handleFileChange,
    handleImageError
  } = photo;
  const initials = useMemo(() => {
    const firstName = (loginVerifyData === null || loginVerifyData === void 0 ? void 0 : loginVerifyData.firstname) || '';
    const lastName = (loginVerifyData === null || loginVerifyData === void 0 ? void 0 : loginVerifyData.lastname) || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';
  }, [loginVerifyData]);
  if (loading) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "400",
      marginBlock: "300",
      role: "status",
      "aria-label": unescapedText('app.myAccountPopover.settings.loadingLabel'),
      children: [/*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-accent-neutral-subtle",
        borderRadius: "full",
        inlineSize: "64px",
        blockSize: "64px"
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "100",
        flexGrow: 1,
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-accent-neutral-subtle",
          borderRadius: "100",
          inlineSize: "140px",
          blockSize: "14px"
        }), /*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-accent-neutral-subtle",
          borderRadius: "100",
          inlineSize: "180px",
          blockSize: "12px"
        })]
      })]
    });
  }
  if (!loginVerifyData) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    marginBlock: "300",
    children: [/*#__PURE__*/_jsxs(Flex, {
      position: "relative",
      inlineSize: "64px",
      blockSize: "64px",
      children: [showImage ? /*#__PURE__*/_jsx(Image, {
        src: displayUrl,
        alt: "Profile",
        shape: "circle",
        responsive: false,
        inlineSize: "64px",
        blockSize: "64px",
        objectFit: "cover",
        bordered: true,
        borderColor: "border-core-default",
        onError: handleImageError
      }) : /*#__PURE__*/_jsx(Flex, {
        backgroundColor: "fill-primary-pressed",
        borderRadius: "full",
        borderWidth: "100",
        borderStyle: "solid",
        borderColor: "border-core-default",
        inlineSize: "64px",
        blockSize: "64px",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Paragraph, {
          color: "text-inverse-default",
          marginBlock: "0",
          typography: "heading-200",
          children: initials
        })
      }), uploading && /*#__PURE__*/_jsx(Flex, {
        position: "absolute",
        insetBlockStart: "0",
        insetInlineStart: "0",
        inlineSize: "64px",
        blockSize: "64px",
        borderRadius: "full",
        backgroundColor: "fill-surface-default",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "xs"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        position: "absolute",
        insetInlineEnd: "0",
        insetBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FileButton, {
          use: "unstyled",
          paddingInline: "0",
          accept: ['image/png', 'image/jpeg'],
          onChange: handleFileChange,
          disabled: uploading,
          "aria-label": unescapedText('app.myAccountPopover.settings.profilePhoto.uploadButton'),
          children: /*#__PURE__*/_jsx(Flex, {
            inlineSize: "24px",
            blockSize: "24px",
            borderRadius: "full",
            backgroundColor: "fill-primary-default",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(InsertImageIcon, {
              size: "100",
              color: "text-primary-default"
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "50",
      alignItems: "start",
      children: [/*#__PURE__*/_jsx(Paragraph, {
        color: "text-core-default",
        marginBlock: "0",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.myAccountPopover.settings.profilePhoto.title"
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        color: "text-core-default",
        marginBlock: "0",
        typography: "detail-200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.myAccountPopover.settings.profilePhoto.description"
        })
      }), /*#__PURE__*/_jsx(FileButton, {
        use: "secondary-ghost",
        size: "small",
        accept: ['image/png', 'image/jpeg'],
        onChange: handleFileChange,
        disabled: uploading,
        children: /*#__PURE__*/_jsx(Paragraph, {
          color: "text-core-default",
          marginBlock: "0",
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.myAccountPopover.settings.profilePhoto.uploadButton"
          })
        })
      })]
    })]
  });
}